module.exports = __webpack_public_path__ + "img/caillebotis-presses.6124ec57.png";